import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { selectAddonTemplateById, setEditId } from "../../../store/mods_factory/addonTemplatesSlice";
import { destroyAddonTemplate, fetchAddonTemplate } from "../../../actions/mods_factory/addonTemplatesActions";
import { fetchCategories } from "../../../actions/mods_factory/categoriesActions";
import modsfactoryUrls from "../../../configs/mods_factory/modsfactoryUrls";

import {
  LikeOutlined,
  MessageOutlined,
  StarOutlined,
  DownloadOutlined
} from "@ant-design/icons";
import { message } from "antd";
import Tabs from "../../../componets/Tabs";
import PageLayout from "../_partials/PageLayout";
import IconText from "../../../componets/IconText";
import StatsIcons from "../../../componets/StatsIcons";
import Edit from "./Edit";
import SummaryShow from "../../../componets/SummaryShow";
import SidebarShow from "./_partials/_SidebarShow";
import EditCategory from "../categories/Edit";
import ReorderCategories from "../categories/Reorder";
import NewCategory from "../categories/New";
import Details from "./_partials/_Details";
import Comments from "./_partials/_Comments";
import EditComment from "../Comments/Edit";
import { ButtonDestroy, ButtonEdit } from "../../../componets/Buttons";

const TARGET_ID = 3;

const Show: React.FC = () => {
  const { id }        = useParams();
  const navigate      = useNavigate();
  const dispatch      = useAppDispatch();
  const addonTemplate = useAppSelector(state => id ? selectAddonTemplateById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchCategories({ target_id: TARGET_ID }));
      dispatch(fetchAddonTemplate(id));
    }
  }, [id, dispatch]);

  function onClickEdit() {
    if (addonTemplate) {
      dispatch(setEditId(addonTemplate.id));
    }
  }

  function onClickDestroy() {
    if (addonTemplate) {
      handleDestroy(addonTemplate.id).catch(console.error);
    }
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyAddonTemplate(id));

    if (destroyAddonTemplate.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(modsfactoryUrls.addonTemplatesPath()), 1000);
    }

    if (destroyAddonTemplate.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  return (
    <PageLayout className='v-addonTemplates-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            addonTemplate &&
              <SummaryShow
                title={addonTemplate.title}
                image={addonTemplate.thumbnail_url}
                createdAt={addonTemplate.created_at}
                updatedAt={addonTemplate.updated_at}
                className='v-mb-15'
                actions={[
                  <ButtonEdit key='button-edit' onClick={onClickEdit} />,
                  <ButtonDestroy key='button-destroy' onClick={onClickDestroy} />
                ]}
              />
          }

          <StatsIcons
            icons={[
              <IconText tooltip='popular' icon={StarOutlined} text={addonTemplate?.popular_count} />,
              <IconText tooltip='likes' icon={LikeOutlined} text={addonTemplate?.likes_count} />,
              <IconText tooltip='downloads' icon={DownloadOutlined} text={addonTemplate?.downloads_count} />,
              <IconText tooltip='comments' icon={MessageOutlined} text={addonTemplate?.comments_count} />
            ]}
          />
        </div>

        <Tabs
          paramsKey='tab'
          items={[
            { label: 'Details', key: 'details', children: <Details addonTemplate={addonTemplate} /> },
            { label: 'Comments', key: 'comment', children: <Comments addonTemplateId={addonTemplate?.id} /> }
          ]}
        />
      </div>

      <SidebarShow addonTemplate={addonTemplate} />

      <Edit />

      <NewCategory />
      <EditCategory />
      <ReorderCategories />

      <EditComment />
    </PageLayout>
  )
}

export default Show;
